<script setup lang="ts">
type CamPortalURL = Parameters<typeof useCamPortalURL>[0];
type MarPortalURL = Parameters<typeof useMarPortalURL>[0];
type HelpPortalURL = Parameters<typeof useHelpPortalURL>[0];
type LegalPortalURL = Parameters<typeof useLegalPortalURL>[0];

const props = defineProps<{
	label: string;
	portal: 'camPortal' | 'mar' | 'help' | 'legal';
	to: string;
}>();

const resolvedUrl = computed(() => {
	switch (props.portal) {
		case 'camPortal':
			return props.to?.trim()
				? useCamPortalURL(props.to as CamPortalURL)
				: useCamPortalURL();
		case 'mar':
			return props.to?.trim()
				? useMarPortalURL(props.to as MarPortalURL)
				: useMarPortalURL();
		case 'help':
			return props.to?.trim()
				? useHelpPortalURL(props.to as HelpPortalURL)
				: useHelpPortalURL();
		case 'legal':
			return props.to?.trim()
				? useLegalPortalURL(props.to as LegalPortalURL)
				: useLegalPortalURL();
		default:
			return '';
	}
});
</script>

<template>
	<HmButton
		:label="props.label"
		:to="resolvedUrl || ''"
		variant="solid"
		icon="arrow-right"
	/>
</template>
